import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useWallet } from '@solana/wallet-adapter-react';
import { useCreatorPublishing } from '../hooks/useCreatorPublishing';
import { callDigitalAssets } from '../utils/digitalAssetsClient';

export default function MintCollectionControls({ comp, ownerPublicKey, onChange, isNew = false }) {
    const wallet = useWallet();
    const uid = wallet.publicKey?.toBase58?.() || '';
    const { collections = [], offers = [], space, loading, error } = useCreatorPublishing(ownerPublicKey);
    const [configuration, setConfiguration] = useState(null);
    const [message, setMessage] = useState('');
    useEffect(() => {
        if (!uid || uid !== ownerPublicKey) return undefined;
        let active = true;
        callDigitalAssets('getConfiguration').then(value => { if (active) setConfiguration(value); })
            .catch(failure => { if (active) setMessage(failure.message); });
        return () => { active = false; };
    }, [uid, ownerPublicKey]);
    const available = collections.filter(item => item.status === 'CONFIRMED' && item.cluster === configuration?.cluster);
    const published = offers.some(item => String(item.componentId) === String(comp.id) && item.status !== 'DRAFT');
    const defaultCollectionId = space?.defaultCollectionId || '';
    useEffect(() => {
        if (isNew && comp.collectionId == null && !loading && configuration && onChange) {
            const defaultId = collections.some(item => item.id === defaultCollectionId && item.status === 'CONFIRMED' && item.cluster === configuration.cluster) ? defaultCollectionId : '';
            onChange(defaultId);
        }
    }, [isNew, comp.collectionId, loading, configuration, collections, defaultCollectionId, onChange]);
    if (!uid || uid !== ownerPublicKey || typeof onChange !== 'function') return null;
    return <div className="mint-collection-controls" style={{ marginTop: 12 }}>
        <label>Collection for new mints
            <select className="muulti-input" value={comp.collectionId || ''} disabled={loading || !configuration || published || !!error} onChange={event => onChange(event.target.value)}>
                <option value="">No collection — use existing Token ID lists</option>
                {available.map(item => <option key={item.id} value={item.id}>{item.name}{space?.defaultCollectionId === item.id ? ' (default)' : ''}</option>)}
                {comp.collectionId && !available.some(item => item.id === comp.collectionId) && <option value={comp.collectionId}>Selected collection unavailable</option>}
            </select>
        </label>
        <p>{published ? 'This component has a published Digital Asset Offer; its collection is managed with that offer.' : 'Publish Updates to apply this selection. Existing NFTs keep their current collection and access lists.'}</p>
        <Link to="/collection-creation">Create a Core Collection</Link>
        {(message || error) && <p role="alert">{message || error}</p>}
    </div>;
}
